<template>
  <div>
    <layout>
      <div slot="content" class="con">
        <swiper
          v-if="goodsList.length>0"
          :options="swiperOption"
          ref="swiperOption"
          class="swiperWrap"
        >
          <swiper-slide
            v-for="(items,index) in goodsList"
            :key="index"
            class="swiperItem"
            :style="'width:'+imgheight+'rem;height:'+(imgheight+0.586)+'rem'"
          >
            <img :src="items.image[0].file_path | thumbnail(1080,1080)"  @click="jump(items.goods_id)"/>
            <div class="title">
              <p>{{items.goods_name}} | {{(items.sku[0].goods_weight* 1000).toFixed(2)}}克</p>
            </div>
          </swiper-slide>
          <div class="pagWrap" slot="pagination"></div>
        </swiper>
      </div>
    </layout>
  </div>
</template>
<script>
import { getList } from "../../api/http.js";
import layout from "@/components/layout.vue";
export default {
  components: {
    layout
  },
  data() {
    return {
      goodsList: [],
      swiperOption: {
        watchSlidesProgress: true,
        slidesPerView: "auto",
        centeredSlides: true,
        loop: true,
        loopedSlide: 5,
        autoplay: false,
        on: {
          progress: function(progress) {
            for (let i = 0; i < this.slides.length; i++) {
              let slide = this.slides.eq(i);
              let slideProgress = this.slides[i].progress;
              let modify = 1;
              // if (Math.abs(slideProgress) > 1) {
              //   modify = (Math.abs(slideProgress) - 1) * 0.1 + 1;
              // }
              let translate = slideProgress * 279 + "px";
              let scale = 1 - Math.abs(slideProgress) / 5;
              let zIndex = 100 - Math.abs(Math.round(10 * slideProgress));

              slide.transform(
                "translateX(" + translate + ") scale(" + scale + ")"
              );
              slide.css("zIndex", zIndex);
              slide.css("opacity", 1);
              if (Math.abs(slideProgress) > 3) {
                slide.css("opacity", 0);
              }
            }
          },
          setTransition: function(transition) {
            for (let i = 0; i < this.slides.length; i++) {
              let slide = this.slides.eq(i);
              slide.transition(transition);
            }
          }
        }
      }
    };
  },
  created() {
    this.init();
  },
   computed: {
    imgheight() {
      return (this.$store.state.screenHeight - 175) / 102.4;
    }
  },
  methods: {
    init() {
      getList(1, "all", true, 0, "", "现货").then(res => {
        this.goodsList = res.data.list.data;
      });
    },
    jump(ids) {
      this.$router.push({
        path: "/details",
        query: {
          //路由传参时push和query搭配使用 ，作用是传递参数
          id: ids
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.con {
  width: 1024px;
  background: url("../../assets/img/detailbg.jpg");
  background-size: 100%100%;
  height: 100%;
  .swiperWrap {
    padding: 10px;
    height: 100%;
    box-sizing: border-box;
    .swiperItem {
      box-shadow: 0 0 20px #5a4e35;
      img {
        display: block;
        width: 100%;
      }
      .title {
        height: 60px;
        background: #2c2c2c;
        overflow: hidden;
        p {
          height: 44px;
          width: 446px;
          margin: 8px auto;
          line-height: 44px;
          font-size: 16px;
          text-align: center;
          background: url("../../assets/img/bordertop.png");
          background-size: 100%100%;
          color: #D6AD58;
        }
      }
    }
  }
}
</style>
<style>
.pagWrap {
  right: 10px;
  top: 50%;
  transform: translate3d(0, -50%, 0);
  position: absolute;
  text-align: center;
  -webkit-transition: 0.3s opacity;
  -o-transition: 0.3s opacity;
  transition: 0.3s opacity;
  z-index: 10;
  bottom: initial !important;
  left: initial !important;
  width: initial !important;
}
.DetailItem {
  border-radius: 100%;
  background: #fff;
  opacity: 0.7;
  width: 8px;
  height: 8px;
  margin: 10px 0;
  display: block;
  line-height: 26px;
}
.DetailItemactive {
  background: #c9a864;
  opacity: 1;
}
</style>


